import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// participant session (localStorage)
export const participant = {
  get: () => {
    const code = localStorage.getItem("part_code");
    const name = localStorage.getItem("part_name");
    return code && name ? { code, name } : null;
  },
  set: (code, name) => {
    localStorage.setItem("part_code", code);
    localStorage.setItem("part_name", name);
  },
  clear: () => {
    localStorage.removeItem("part_code");
    localStorage.removeItem("part_name");
  },
};
